module.exports = __webpack_public_path__ + "static/media/vday2.fcfbffbd.jpeg";